
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { BusinessUnitDetailDto_$reflection } from "../../Shared/BusinessUnit.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, BusinessUnitId_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { union_type, string_type, class_type, record_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(BusinessUnit, BusinessUnitId, FormState) {
        super();
        this.BusinessUnit = BusinessUnit;
        this.BusinessUnitId = BusinessUnitId;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("BusinessUnit.Detail.Types.State", [], State, () => [["BusinessUnit", RequestedValue$1_$reflection(BusinessUnitDetailDto_$reflection())], ["BusinessUnitId", BusinessUnitId_$reflection()], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UploadImage", "DeleteImage", "ImageDeleted", "ImageSaved", "BlobReceived", "BusinessUnitFetched", "BusinessUnitDeleted", "BusinessUnitSaved", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("BusinessUnit.Detail.Types.Msg", [], Msg, () => [[["Item", class_type("Browser.Types.File", undefined)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", BusinessUnitDetailDto_$reflection()]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

